import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { postCloneActivity } from './api';
import { ActivityCloneDTO } from './dto/ActivityCloneDTO';
import { useHistory } from 'react-router';
import { QueryKey } from '@behavior/QueryKey';

function usePostCloneActivity() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const history = useHistory();

  const { mutateAsync, isLoading } = useMutation(
    (activity: ActivityCloneDTO) => postCloneActivity(activity),
    {
      onSuccess: data => {
        queryClient.setQueryData([QueryKey.ACTIVITY, data.activity?.id], data);
        history.push(`/activity/view/${data.activity?.id}`);
      },
      onError: error => {
        toast.error(t('message.title.error.post.clone.activity'));
      },
    }
  );
  return { postCloneActivity: mutateAsync, isLoadingCloneActivity: isLoading };
}

export default usePostCloneActivity;
